import fadeIn from './fade-in.js'
Vue.directive('fadeIn', fadeIn)



// WEBPACK FOOTER //
// ./src/js/directives/fade-in/index.js